module.exports = __webpack_public_path__ + "img/302721_CAC1BB_7A706A_91959B-256px.24aa74bf.png";